import { render, staticRenderFns } from "./m-group-signatarios.vue?vue&type=template&id=6e9c0281&"
import script from "./m-group-signatarios.vue?vue&type=script&lang=js&"
export * from "./m-group-signatarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports